import { render } from "./AdminMailjetEventMirrorWorkflow.vue?vue&type=template&id=2db6a285&scoped=true"
import script from "./AdminMailjetEventMirrorWorkflow.vue?vue&type=script&lang=js"
export * from "./AdminMailjetEventMirrorWorkflow.vue?vue&type=script&lang=js"

import "./AdminMailjetEventMirrorWorkflow.vue?vue&type=style&index=0&id=2db6a285&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db6a285"]])

export default __exports__